<div class="HomeSlider" appMySwipe (mySwipeLeft)="onSwipeLeft($event)" (mySwipeRight)="onSwipeRight($event)">
    <div class="slidesHolder">
        <div class="slides" #slides>
            <div class="slide" [class]="item.id" *ngFor="let item of data.slides">
                <div class="bg">
                    <img [src]="!isMobile ? item.bg : item.bgMobile" alt="">
                    <video [src]="!isMobile? item.video : item.videoMob "
                        *ngIf="(!isMobile && item.video != '') || (isMobile && item.videoMob != '') " #videoEl
                        [poster]="!isMobile ? item.bg : item.bgMobile" [muted]="true" playsInline="true"
                        [autoplay]="true" [loop]="false" appVideoHandler (ended)="onVideoEnded($event)"></video>
                </div>

                <div class="ttHolder" *ngIf="!isMobile">
                    <div [class]=" 'ttWrapper ' + item.id">
                        <img [src]="item.tt" alt="" *ngIf="item.tt != ''">
                    </div>
                </div>

                <div class="contentWrapper" [class]="item.id" [ngClass]="{large: item.isLargeLogo}">
                    <div class="content" [ngClass]="{large: item.isLargeLogo}">
                        <div *ngIf="!isMobile" class="tag" [innerHTML]="item.tag | safeHtml"></div>
                        <a [routerLink]="item.button.url" class="logoLink">
                            <div class="logoHolder" [class]="item.id">
                                <img [src]="item.logo" alt="" *ngIf="!item.isLargeLogo">
                                <img [src]="item.largeLogo" alt="" *ngIf="item.isLargeLogo && !isMobile">
                                <img [src]="item.logoMobile" alt="" *ngIf="item.isLargeLogo && isMobile">
                            </div>
                        </a>
                        <div *ngIf="!isMobile || item.isLargeLogo " class="description" [class]="item.id"
                            [innerHTML]="item.description | safeHtml" [ngStyle]="{color: item.descriptionColor}"></div>

                        <div class="buttons">

                            <a [routerLink]="item.button.url" class="button">
                                <div class="bg" [ngStyle]="{backgroundColor: item.button.colorBG}"></div>
                                <div class="label" [innerHTML]="item.button.label"
                                    [ngStyle]="{color: item.button.color}"></div>
                            </a>

                            <a class="button" (click)="onOpenSizzleOverlay(item.button.url)"
                                *ngIf="item.sizzleVideoLabel != ''">
                                <div class="bg" [ngStyle]="{backgroundColor: item.button.colorBG}"></div>
                                <div class="label" [ngStyle]="{color: item.button.color}">
                                    <div class="icon">
                                        <!-- <img src="assets/img/home/play-icon-small.png" alt=""> -->
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256"
                                            height="256" viewBox="0 0 256 256" xml:space="preserve">

                                            <defs>
                                            </defs>
                                            <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                                                transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                                                <path [ngStyle]="{fill: item.button.color}"
                                                    d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 10 c -19.299 0 -35 15.701 -35 35 s 15.701 35 35 35 s 35 -15.701 35 -35 S 64.299 10 45 10 z"
                                                    style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;  fill-rule: nonzero; opacity: 1;"
                                                    transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                <path [ngStyle]="{fill: item.button.color}"
                                                    d="M 61.806 47.026 c 1.559 -0.9 1.559 -3.151 0 -4.051 l -12.91 -7.453 l -12.91 -7.453 c -1.559 -0.9 -3.509 0.225 -3.509 2.026 V 45 v 14.907 c 0 1.801 1.949 2.926 3.509 2.026 l 12.91 -7.453 L 61.806 47.026 z"
                                                    style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;  fill-rule: nonzero; opacity: 1;"
                                                    transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                            </g>
                                        </svg>
                                    </div>
                                    <span [innerHTML]="item.sizzleVideoLabel"></span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="playPauseButton">
        <app-video-play-pause-button [data]="videoEl?.toArray()[0]"></app-video-play-pause-button>
    </div>

    <div class="thumbsWrapper">
        <div class="thumbs">
            <div class="thumb" *ngFor="let item of data.slides; let i=index">
                <div class="thumbHolder" (click)="onSelect(i)" [ngClass]="{selected: selected == i}">
                    <img [src]="!isMobile ? item.thumb : item.thumbMobile" alt="">
                </div>
            </div>

        </div>
    </div>
</div>